import React, { useState } from 'react';
import { v4 } from 'uuid';
import Dialog from 'components/shared/Dialog';
import Button from 'components/shared/Button';

function RebootConfirmDialog({ title, description, open, onCancel, onConfirm }) {
  const [titleId] = useState(() => v4());

  return (
    <Dialog role="alertdialog" aria-labelledby={titleId} open={open}>
      <Dialog.Container maxWidth={640}>
        <Dialog.Title id={titleId}>{title}</Dialog.Title>
        {description && <Dialog.Content>{description}</Dialog.Content>}
        <Dialog.Actions>
          <Button variant="text" color="primary" size="medium" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" size="medium" onClick={onConfirm}>
            Confirm
          </Button>
        </Dialog.Actions>
      </Dialog.Container>
    </Dialog>
  );
}

export default RebootConfirmDialog;
